import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import Magnetic from "./motion/Magnetic";

const base =
  "group/btn relative inline-flex items-center gap-3 px-8 py-4 text-sm font-semibold tracking-wide transition-[transform,box-shadow,color,background-color,border-color] duration-500";

const VARIANTS = {
  primary: `${base} btn-sweep bg-pine text-sand hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-18px_rgba(29,90,70,0.6)] hover:text-ink`,
  gold: `${base} btn-sweep btn-sweep-dark bg-terra text-ink hover:-translate-y-0.5 hover:text-sand hover:shadow-[0_18px_40px_-18px_rgba(212,145,26,0.6)]`,
  outline: `${base} border border-pine/60 text-pine hover:border-pine hover:bg-pine hover:text-sand`,
  outlineLight: `${base} border border-sand/50 text-sand hover:border-sand hover:bg-sand hover:text-pine`,
  ghost: "group/btn inline-flex items-center gap-2 text-sm font-semibold text-pine link-line",
};

export default function Button({ to, href, variant = "primary", children, arrow = "right", className = "", ...rest }) {
  const Icon = arrow === "up" ? ArrowUpRight : ArrowRight;
  const content = (
    <>
      <span className="relative z-10">{children}</span>
      {arrow && (
        <Icon className="relative z-10 h-4 w-4 transition-transform duration-500 group-hover/btn:translate-x-1" />
      )}
    </>
  );
  const cls = `${VARIANTS[variant]} ${className}`;
  const el = to ? (
    <Link to={to} className={cls} {...rest}>
      {content}
    </Link>
  ) : href ? (
    <a href={href} className={cls} {...rest}>
      {content}
    </a>
  ) : (
    <button className={cls} {...rest}>
      {content}
    </button>
  );
  if (variant === "ghost") return el;
  return <Magnetic strength={0.25}>{el}</Magnetic>;
}
